export { default as api } from './api/reducer';
export { default as searchForm } from './searchForm/reducer';
export { default as announcements } from './announcements/reducer';
export { default as error } from './error/reducer';
export { default as cache } from './cache/reducer';
export { default as history } from './history/reducer';
export { default as settings } from './settings/reducer';